import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faRoute, faXmark} from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import EpicGoogleMap from './EpicGoogleMap';
import './NavigationButtons.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const NavigationButtons = ({ from, to, travelMode = 'transit', selectedRoute }) => {
  const [showMapOverlay, setShowMapOverlay] = useState(false);
  const handleNavigate = () => {
    const navigateUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(from)}&destination=${encodeURIComponent(to)}&travelmode=${travelMode}`;
    console.log('Navigation URL:', navigateUrl);
    window.open(navigateUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
    <div className="navigation-buttons">
      {/* Map Button */}
      {!showMapOverlay &&
      <button
        onClick={() => setShowMapOverlay(true)}
        disabled={!selectedRoute}
        className="nav-button"
      >
        <FontAwesomeIcon icon={faMapMarkedAlt} />
        <span>Map</span>
      </button>
      }

      {/* Navigate Full Route Button */}
      <button
        onClick={handleNavigate}
        className="nav-button"
      >
        <FontAwesomeIcon icon={faRoute} />
        <span>Navigate</span>
      </button>
    </div>
    {showMapOverlay && selectedRoute &&
    <div className="map-overlay">
      <div className="map-overlay-content">
        <button onClick={() => setShowMapOverlay(false)} className="close-btn"><FontAwesomeIcon icon={faArrowLeft} /></button>
        <EpicGoogleMap from={from} to={to} fullRoutes={[selectedRoute]} />
      </div>
    </div>
    }
    </>
  );
};

export default NavigationButtons; 